export const HOME = {
	navWordmark: 'nav-wordmark',
	navHowItWorks: 'nav-how-it-works-link',
	navSolutions: 'nav-solutions-link',
	navOrganizations: 'nav-organizations-link',
	navCta: 'nav-assessment-cta',
	navMenuToggle: 'nav-menu-toggle',
	heroHeadline: 'hero-headline',
	heroStartCta: 'hero-start-assessment-button',
	heroHowCta: 'hero-see-how-button',
	marquee: 'needs-marquee',
	aiTools: 'ai-tools-strip',
	entrySection: 'entry-section',
	needOption: 'entry-need-option',
	detailsTextarea: 'entry-details-textarea',
	entryError: 'entry-validation-error',
	analyzeButton: 'entry-analyze-button',
	placeholder: 'entry-rotating-placeholder',
	example: 'entry-example',
	replaceConfirm: 'entry-example-replace-button',
	keepMine: 'entry-example-keep-button',
	selectedNeed: 'entry-selected-need',
};

export const DIAGNOSTIC = {
	page: 'diagnostic-page',
	previewNotice: 'diagnostic-preview-notice',
	status: 'diagnostic-preview-status',
	intro: 'diagnostic-intro-heading',
	context: 'diagnostic-submitted-context',
	editNeed: 'diagnostic-edit-need-button',
	question: 'diagnostic-question',
	answer: 'diagnostic-answer-textarea',
	continueButton: 'diagnostic-continue-button',
	complete: 'diagnostic-end-of-preview',
	editAnswer: 'diagnostic-edit-answer-button',
	returnHome: 'diagnostic-return-home-button',
	startOver: 'diagnostic-start-over-button',
	emptySession: 'diagnostic-empty-session',
	exit: 'diagnostic-exit-link',
};
